import styled from "@emotion/styled";

export const Root = styled.td({
    padding: "0 5px 0 0",
    lineHeight: "36px",
    position: "relative",
});
